import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, withModifiers as _withModifiers, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-2642e111"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "content-wrapper vh-100" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "電話番号認証", -1))
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "description" }, "\n            電話番号を入力しましょう\n          ", -1))
const _hoisted_4 = ["value"]

import { computed, h, onMounted, ref } from "vue";
import { authService } from "@/app/services/AuthService";
import AppButton from "@/components/atoms/button/AppButton.vue";
import AppButtonOutline from "@/components/atoms/button/AppButtonOutline.vue";
import FormInvalidFeedback from "@/components/atoms/other/FormInvalidFeedback.vue";
import FeatherIcon from "@/components/atoms/other/FeatherIcon.vue";
import Header from "@/components/organisms/common/Header.vue";
import ExternalLink from "@/const/externalLink";
import { authStore } from "@/store/auth";
import { AbTest3113 } from "@/app/services/AbTestService";
import { useLoader } from "@/utils/loader";
import { useModal } from "@/utils/modal";
import { useCustomRouter } from "@/utils/router";


export default /*#__PURE__*/_defineComponent({
  __name: 'RegisterOrLogin',
  setup(__props) {

const modal = useModal();
const loader = useLoader();
const customRouter = useCustomRouter();
const phoneNumber = ref("");
const phoneNumberInputRef = ref<HTMLInputElement | null>(null);
const phoneNumberWithoutSpace = computed((): string => {
  return phoneNumber.value.replace(/\s/g, "");
});

onMounted(() => {
  if (phoneNumberInputRef.value) phoneNumberInputRef.value.focus();
});

// この画面を表示した際に新規登録に関するstoreの情報をクリアする
authStore.clearRegisterInfo();

async function nextStep() {
  try {
    loader.show();
    // NOTE: 不正なトークンがあった場合、このタイミングで削除しなければAPIに渡されてしまいエラーになってしまう。
    // そのためこのタイミングで認証情報は一度リセットさせる
    authStore.logout();

    const status = await authService.fetchAccountStatus(
      phoneNumberWithoutSpace.value
    );
    // 停止済みユーザーの場合
    if (status === "ban") {
      showInactiveUserModal();
      return;
    }

    AbTest3113.registerEvent(AbTest3113.eventTypes.enterPhoneNumberNext);

    // 認証が必要なユーザーの場合、電話番号認証画面へ
    if (status === "requiredPhoneNumberAuth") {
      customRouter.pushIgnoreError({
        name: "RegisterPhoneNumberAuth",
        query: { phoneNumber: phoneNumberWithoutSpace.value }
      });
      return;
    }

    // 上記以外（アクティブな登録済みユーザー）の場合、ログイン画面へ
    customRouter.pushIgnoreError({
      name: "Login",
      query: { phoneNumber: phoneNumberWithoutSpace.value }
    });
    return;
  } catch {
    // serviceNameが不正な場合
    await modal.msgBoxOk("不正な操作です", {
      centered: true
    });
  } finally {
    loader.hide();
  }
}

function showInactiveUserModal() {
  const messageVNode = h("div", [
    h("p", "一時的に利用停止中のためログインできません。"),
    h("p", "利用停止期間を過ぎましたら、アカウントが復帰されます。"),
    h("p", [
      "アカウントが復帰されない場合は、運営事務局へお問い合わせください。",
      h(
        AppButtonOutline,
        {
          class: "mb-1 mt-3",
          href: ExternalLink.CONTACT,
          size: "small",
          block: true
        },
        "お問い合わせフォーム"
      )
    ])
  ]);
  // @ts-ignore
  modal.msgBoxOk(messageVNode, {
    centered: true
  });
}

function onPhoneNumberInput(event: Event) {
  const target = event.target as HTMLInputElement;
  let value = target.value;
  // 空白を削除
  value = value.replace(/\s/g, "");
  // 数字以外の入力を無視
  if (!/^\d*$/.test(value)) {
    value = value.replace(/\D/g, "");
  }

  if (value.length > 11) {
    value = value.slice(0, 11);
  }
  value = formatPhoneNumber(value);
  phoneNumber.value = value;
  target.value = value;
}
function formatPhoneNumber(value: string) {
  // 3桁 4桁 4桁に区切る。11桁ない場合も考慮
  const first = value.slice(0, 3);
  const second = value.slice(3, 7);
  const third = value.slice(7, 11);
  return [first, second, third].filter(v => v).join(" ");
}

return (_ctx: any,_cache: any) => {
  const _component_ValidationProvider = _resolveComponent("ValidationProvider")!
  const _component_BForm = _resolveComponent("BForm")!
  const _component_CustomValidationObserver = _resolveComponent("CustomValidationObserver")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(Header, null, {
      left: _withCtx(() => [
        _createVNode(FeatherIcon, {
          icon: "chevron-left",
          onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$router.back()))
        })
      ]),
      default: _withCtx(() => [
        _createTextVNode(),
        _hoisted_2
      ], undefined, true),
      _: 1
    }),
    _createTextVNode(),
    _createVNode(_component_CustomValidationObserver, {
      ref: "form",
      tag: "div",
      class: "w-100"
    }, {
      default: _withCtx(({ handleSubmit, valid }) => [
        _createVNode(_component_BForm, {
          onSubmit: _withModifiers(($event: any) => (handleSubmit(nextStep)), ["stop","prevent"])
        }, {
          default: _withCtx(() => [
            _createElementVNode("main", null, [
              _hoisted_3,
              _createTextVNode(),
              _createVNode(_component_ValidationProvider, {
                name: "電話番号",
                rules: "phonenumber_with_space",
                vid: "phoneNumber",
                class: "w-100"
              }, {
                default: _withCtx((validationState) => [
                  _createElementVNode("input", {
                    ref_key: "phoneNumberInputRef",
                    ref: phoneNumberInputRef,
                    value: phoneNumber.value,
                    onInput: onPhoneNumberInput,
                    type: "tel",
                    class: "phone-number-input",
                    placeholder: "080 1234 5678"
                  }, null, 40, _hoisted_4),
                  _createTextVNode(),
                  validationState
                    ? (_openBlock(), _createBlock(FormInvalidFeedback, {
                        key: 0,
                        "validation-state": validationState,
                        state: false
                      }, null, 8, ["validation-state"]))
                    : _createCommentVNode("", true)
                ]),
                _: 1
              }),
              _createTextVNode(),
              _createVNode(AppButton, {
                onClick: nextStep,
                rounded: "",
                disabled: !valid,
                class: "next-button"
              }, {
                default: _withCtx(() => [
                  _createTextVNode("次へ")
                ], undefined, true),
                _: 2
              }, 1032, ["disabled"])
            ])
          ], undefined, true),
          _: 2
        }, 1032, ["onSubmit"])
      ]),
      _: 1
    }, 512)
  ]))
}
}

})